import React, { useState } from 'react';
import { Modal, Select, Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import styles from './ItemTypeModal.module.scss';

const { Option } = Select;

interface ItemTypeModalProps {
  visible: boolean;
  onCancel: () => void;
}


const ItemTypeModal: React.FC<ItemTypeModalProps> = ({ visible, onCancel }) => {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState<string>('');

  const handleNext = () => {
    if (!selectedType) {
      return;
    }
    // Navigate to add-item form with the selected type
    navigate(`/add-item?type=${selectedType}`);
    setSelectedType('');
  };

  const handleCancel = () => {
    setSelectedType('');
    onCancel();
  };

  return (
    <Modal
      title={
        <div className={styles.modalTitle}>
          <h2>Choose Your Item Type</h2>
        </div>
      }
      visible={visible}
      onCancel={handleCancel}
      footer={null}
      closeIcon={<CloseOutlined />}
      centered
      width={800}
      className={styles.itemTypeModal}
    >
      <div className={styles.modalContent}>
        <label className={styles.label}>Select Item type</label>
        <Select
          placeholder="Select Item Type"
          value={selectedType}
          onChange={setSelectedType}
          className={styles.selectInput}
        >
          <Option value="avatar">Avatar</Option> 
          <Option value="agent">Agent</Option>
          {/* <Option value="model">Model</Option>
          <Option value="data">Data</Option>*/}
           <Option value="skill">Skill</Option> 
          <Option value="wearables">Wearable</Option>
          <Option value="workflow">Workflow</Option>
        </Select>

        <div className={styles.buttonGroup}>
          <Button
            className={styles.cancelButton}
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            className={styles.nextButton}
            onClick={handleNext}
            disabled={!selectedType}
          >
            Next
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ItemTypeModal;
